import { useContext } from "react";
import AuthContext from "../context/AuthContext"

const useAuth = () => {
    const authContext = useContext(AuthContext);
    if (!authContext) {
        throw new Error('AuthContext has to be used within <AuthContext.Provider>');
    } else {
        return authContext;
    }
}

export default useAuth;